export default __webpack_public_path__ + "static/images/0770b44f95be0f5fedf6feae6aa82b7a.png";